<template>
  <v-layout row wrap align-center justify-center class="secondary lighten-1">
    <v-container grid-list-lg>
      <h1 class="display-1 white--text mb-5">Applications</h1>
      <v-layout row wrap>
        <v-hover v-for="item in queryItemsList" :key="item.pathName">
          <v-flex xs4 slot-scope="{ hover }">
            <v-card class="vop-bg-whisper secondary--text pointer" :class="`elevation-${hover ? 12 : 2}`"
              @click="navigateTo(item.pathName)">
              <v-card-title primary-title>
                <div>
                  <v-icon large class="secondary--text">{{ item.icon }}</v-icon>
                  <div class="headline">{{ item.title }}</div>
                  <span class="grey--text body-2 text--darken-2">{{ item.description }}</span> <br />
                  <span class="grey--text caption text--darken-2"
                    v-if="item.auth === 'MPX' && !IS_SIGNED_INTO_MPX">Authenticate with mpx</span>
                  <span class="grey--text caption text--darken-2"
                    v-if="item.auth === 'CABLE' && !IS_SIGNED_INTO_CABLE">Authenticate with CABLE (sso)</span>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-hover>
        <v-hover v-for="item in configurationItemsList" :key="item.pathName">
          <v-flex xs4 slot-scope="{ hover }">
            <v-card class="vop-bg-whisper secondary--text pointer" :class="`elevation-${hover ? 12 : 2}`"
              @click="navigateTo(item.pathName)">
              <v-card-title primary-title>
                <div>
                  <v-icon large class="secondary--text">{{ item.icon }}</v-icon>
                  <div class="headline">{{ item.title }}</div>
                  <span class="grey--text body-2 text--darken-2">{{ item.description }}</span> <br />
                  <span class="grey--text caption text--darken-2"
                    v-if="item.auth === 'MPX' && !IS_SIGNED_INTO_MPX">Authenticate with mpx</span>
                  <span class="grey--text caption text--darken-2"
                    v-if="item.auth === 'CABLE' && !IS_SIGNED_INTO_CABLE">Authenticate with CABLE (sso)</span>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-hover>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"

import AppService from "@/AppService"
import { IS_SIGNED_INTO_CABLE, IS_SIGNED_INTO_MPX } from "@/store/constants/getter-types"

export default {
  name: "Home",
  data() {
    return {
      queryItems: AppService.getQueryItems(),
      configurationItems: AppService.getConfigurationItems()
    }
  },
  computed: {
    ...mapGetters([
      IS_SIGNED_INTO_CABLE,
      IS_SIGNED_INTO_MPX
    ]),
    queryItemsList() {
      return this.filterVisibileFeaturesList(this.queryItems)
    },
    configurationItemsList() {
      return this.filterVisibileFeaturesList(this.configurationItems)
    }
  },
  methods: {
    /**
     *  navigateTo
     * @param {string} pathName
     */
    navigateTo(pathName) {
      this.$router.push({
        name: pathName
      })
    },
    /**
     * filterVisibileFeaturesList
     * @param {array} featureItems
     * @returns {array}
     */
    filterVisibileFeaturesList(featureItems) {
      return this.$lodash.filter(featureItems, (item) => {
        let isVisible = AppService.isFeatureVisible(item.featureName)
        return isVisible
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/Home/Home.vue